import _throttle from 'lodash/throttle';
import { useState } from 'react';

export const useInfiniteScroll = (
  gridRef,
  hasNextPage,
  loadNext,
  rows = 10
) => {
  const [isLoading, setIsLoading] = useState(false);

  const loadMore = _throttle(async () => {
    const {scrollTop, scrollHeight, children} = gridRef.current;

    if (!isLoading && hasNextPage) {
      const LEFT_TO_SCROLL = scrollHeight - scrollTop;
      const ROW = children[0].clientHeight;

      if ((LEFT_TO_SCROLL) < (ROW * rows)) {
        setIsLoading(true);
        await loadNext();
        setIsLoading(false);
      }
    }
  }, 500);

  return { isLoading, loadMore };
};
